import { Injectable } from "@angular/core";
import { PKCEVerifierService } from "../../../p-k-c-e/p-k-c-e-verifier.service";
import { PKCECodeChallengeService } from "../../../p-k-c-e/p-k-c-e-code-challenge.service";
import { PKCEAuthorizationRequestService } from "../../../p-k-c-e/p-k-c-e-authorization-request.service";
import { PKCEAuthorizationCodeExchangeService } from "../../../p-k-c-e/authorization-code-exchange/p-k-c-e-authorization-code-exchange.service";
import { CodeChallengeStorageService } from "../../../p-k-c-e/code-challenge-storage.service";
import { AuthModule } from "../../../auth.module";
import { AuthorityService } from '../../../authority/authority.service';

@Injectable({
  providedIn: AuthModule,
})
export class PKCEGrantService {
  constructor(
    private authorizationRequestService: PKCEAuthorizationRequestService,
    private verifierService: PKCEVerifierService,
    private codeChallengeService: PKCECodeChallengeService,
    private authorizationCodeExchangeService: PKCEAuthorizationCodeExchangeService,
    private codeChallengeStorageService: CodeChallengeStorageService
  ) {}

  createPkceAuthorizationCodeRequestUrl() {
    return this.authorizationCodeExchangeService.createAuthorizationCodeRequestUrl();
  }

  generateVerifier() {
    return this.verifierService.generateVerifier();
  }

  storeVerifier(v) {
    return this.verifierService.storeVerifier(v);
  }

  loadVerifier() {
    return this.verifierService.loadVerifier();
  }

  loadCodeChallenge() {
    return this.codeChallengeStorageService.loadCodeChallenge();
  }

  storeCodeChallenge(codeChallenge) {
    this.codeChallengeStorageService.storeCodeChallenge(codeChallenge);
  }

  createAuthorizationRequestUrl(code_challenge, prompt?) {
    return this.authorizationRequestService.createAuthorizationRequestUrl(
      code_challenge,
      prompt
    );
  }

  async createCodeChallenge(verifier) {
    return await this.codeChallengeService.createCodeChallenge(verifier);
  }

  runAuthorizationCodeExchange(code, verifier) {
    return this.authorizationCodeExchangeService.run(code, verifier);
  }

  createAuthorizationCodeRequestUrl() {
    return this.authorizationCodeExchangeService.createAuthorizationCodeRequestUrl();
  }
}
